import { configureStore } from '@reduxjs/toolkit';
import authReducer  from './slices/authSlice';
import storeReducer from './slices/storeSlice';
import playlistReducer from './slices/playlistSlice.ts';

export const store = configureStore({
  reducer: {
    auth:     authReducer,
    store:    storeReducer,
    playlist: playlistReducer,
  },
});

export type RootState   = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
